const asideToggler = () => {

    let asideButton = document.querySelectorAll(".li-header");

    for( let i = 0; i < asideButton.length; i++ ) {
        asideButton[i].addEventListener( "click", function() {
            
            let asideBlock = asideButton[i].closest(".aside-li");
            let iconImg = asideButton[i].querySelector("img");

            if( asideBlock.classList.contains("active") ) {
                iconImg.setAttribute("src", "https://bestonlinecasino-australia.net/wp-content/themes/australia-casino/images/down.svg")
            } else {
                iconImg.setAttribute("src", "https://bestonlinecasino-australia.net/wp-content/themes/australia-casino/images/down_active.svg")
            }

            asideBlock.classList.toggle("active");
        });
    }

}

export default asideToggler;